import styled from "styled-components"

export const FormSearchWrapper = styled.div`

    .form-search {
    height: 35px;
    display: flex;
    input {
        border: none;
        outline: none;
        height: 100%;
        width: 300px;
        font-size: 1rem;
        padding: 0 12px;
    }
    .btn_search {
        outline: none;
        border: none;
        width: 35px;
        cursor: default;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
            color: #fff;
        }
    }
    .btn_clear {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #fff;
        width: 30px;
        i {
            background-color: #e9e9e9;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 0.8rem;
            cursor: pointer;
            &:hover{
                background-color: #e2c1c1;
            }
        }
    }
    &:focus-within {
        box-shadow: 1px 1px 4px rgba(1, 1, 1, 30%);
    }
}
`
